module.exports = __webpack_public_path__ + "static/warpcutoff-f0612870fec820eaafcd4a8c8f6e023d.png";